import { NextRequest, NextResponse } from "next/server";

import {
    COOKIES,
    CountryRegion,
    CountryRegionToCountrySlug,
} from "constants/enum";

import { getGeoDataByIP } from "./getGeoDataByIP";
import { getCityByCoords } from "./getCityByCoords";

export const hydrateWithGeoData = async (
    req: NextRequest,
    resp: NextResponse
) => {
    const geoBlocker = req.cookies.get(COOKIES.GEO_BLOCK);
    if (geoBlocker) return resp;

    const cityIdFromCookies = req.cookies.get(COOKIES.GEO_CITY_ID)?.value;
    const countryFromCookies = req.cookies.get(
        COOKIES.GEO_SEARCH_COUNTRY
    )?.value;
    const version =
        CountryRegionToCountrySlug[req.nextUrl.locale as CountryRegion];
    const countryHasChanged = countryFromCookies !== version;

    // If city ID is already in cookies - skip geoData, but only if user hadn't changed the country
    if (cityIdFromCookies && version && !countryHasChanged) return resp;

    // Return coords from cookies if not empty or makes an API request
    const geoData = getGeoDataByIP(req, resp);
    if (!geoData) return resp;

    const { latitude, longitude } = geoData;
    await getCityByCoords(
        req,
        resp,
        version,
        latitude as string,
        longitude as string,
        countryHasChanged
    );
    return resp;
};
